import React from 'react'
import Box from '../../../core/components/box/Box'
import Text from '../../../core/components/typography/text/Text'
import Heading from '../../../core/components/typography/heading/Heading'
import ContextFlyout from '../../../core/components/flyout/ContextFlyout'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import lightningSVG from '../../../core/img/lightning.svg'
// import trophySVG from '../../../core/img/trophy.svg'

export default class StreakMeter extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      streakFlyoutOpen: false,
      bestStreakFlyoutOpen: false,
    }

    this.streakHoverStart = this.streakHoverStart.bind(this)
    this.streakHoverEnd = this.streakHoverEnd.bind(this)
    this.streakTouchToggle = this.streakTouchToggle.bind(this)

  }

  componentDidMount() {
    window.addEventListener('touchstart', this.streakHoverEnd, false)
  }
  componentWillUnmount() {
    window.removeEventListener('touchstart', this.streakHoverEnd, false)
  }

  streakHoverStart(e) {
    this.setState({
      streakFlyoutOpen: true
    })
  }
  streakHoverEnd(e) {
    this.setState({
      streakFlyoutOpen: false
    })
  }
  streakTouchToggle(e) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      streakFlyoutOpen: !this.state.streakFlyoutOpen
    })
  }

  render() {
    const {streak, bestStreak, subjectColorId} = this.props
    const {streakFlyoutOpen} = this.state
    const lightningStyle = streak === 0
      ? {
        filter: 'grayscale(100%) brightness(1000%)'
      }
      : {}
    return (
      <div
        ref={node => this.streakNode = node}
        onMouseEnter={this.streakHoverStart}
        onMouseLeave={this.streakHoverEnd}
        onTouchStart={this.streakTouchToggle}>
        <Box
          display='flex'
          flexShrink={0}
          minWidth='3rem'
          justifyContent='end'
          color={`${SubjectToCSSName[subjectColorId]}-cta`}
          shape='circle'
          paddingY={3}
          paddingX={6}>
          <Box display='flex' alignItems='center' justifyContent='center'>
            <Box marginRight={2} display='flex' alignItems='center'>
              <img src={lightningSVG} style={lightningStyle} />
            </Box>
            <Text
              color={streak > 0 && streak === bestStreak ? 'streakYellow' : 'white'}
              fontWeight='medium'
              size='lg'>
              {streak}
            </Text>
          </Box>
        </Box>
        {
          streakFlyoutOpen &&
        <ContextFlyout
          anchor={this.streakNode}
          onDismiss={this.streakHoverEnd}
          idealDirection='down'
          size='sm'
          zIndex={3}
        >
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            paddingY={4}
            width='100%'
          >
            <Box display='flex' direction='column' alignItems='center' marginRight={6}>
              <Box marginBottom={1}>
                <Heading
                  color='white'
                  fontWeight='bold'
                  size='xl'>{streak}</Heading>
              </Box>
              <Text
                color='white'
                fontWeight='medium'
                size='sm'>
                STREAK
              </Text>
            </Box>
            <Box display='flex' direction='column' alignItems='center'>
              <Box marginBottom={1}>
                <Heading
                  color='white'
                  fontWeight='bold'
                  size='xl'>{bestStreak}</Heading>
              </Box>
              <Text
                color='white'
                fontWeight='medium'
                size='sm'>
                BEST STREAK
              </Text>
            </Box>
          </Box>
        </ContextFlyout>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/StreakMeter.js